module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp23_7.01728d65.png";